import classNames from "classnames";
import { useCallback } from "react";

import { useBuilderTheme } from "hooks/use-builder-theme";
import { SwitchToggleContainer, SwitchToggleSize } from "./switch-toggle-styles";

interface Props {
    readonly toggled: boolean;
    readonly size: SwitchToggleSize;
    readonly onChange: (checked: boolean) => void;
}

const SwitchToggle = (p: Props) => {
    const { toggled, onChange, size } = p;

    const theme = useBuilderTheme();

    const onToggled = useCallback(() => {
        onChange(!toggled);
    }, [onChange, toggled]);

    const className = classNames(toggled && "enabled");

    return (
        <SwitchToggleContainer
            className={className}
            data-test={"switch-tgl"}
            onClick={onToggled}
            color={theme.acceptColor}
            size={size}>
            <div className="check">
                <div className="thumb" />
            </div>
        </SwitchToggleContainer>
    );
};

export default SwitchToggle;
